import { create } from 'zustand';

// Composed action modules
import { createSessionActions, SessionState, SessionActions } from './auth/session-actions';
import { createValidationActions, ValidationActions } from './auth/validation-actions';
import { createErrorActions, ErrorState, ErrorActions } from './auth/error-actions';
import { createWaitlistActions, WaitlistState, WaitlistActions } from './auth/waitlist-actions';
import { createAuthMethodActions, AuthMethodState, AuthMethodActions } from './auth/auth-method-actions';

// Combined interface
interface AuthState extends 
  SessionState, 
  ErrorState, 
  WaitlistState, 
  AuthMethodState,
  SessionActions, 
  ValidationActions, 
  ErrorActions, 
  WaitlistActions,
  AuthMethodActions {}

export const useAuthStore = create<AuthState>((set, get) => ({
  // === INITIAL STATE ===
  
  // Session state
  user: null,
  session: null,
  isInitializing: false,
  isValidatingSession: false,
  isSigningOut: false,
  sessionValidated: false,
  
  // Error state
  sessionError: null,
  authError: null,
  storageBlocked: false,
  
  // Waitlist state
  waitlist: null,

  // Auth method state
  lastAuthMethod: null,
  isAuthMethodLoading: false,

  // === COMPOSED ACTIONS ===
  
  // Session management actions
  ...createSessionActions(set, get),
  
  // Auth validation actions
  ...createValidationActions(set, get),
  
  // Error handling actions
  ...createErrorActions(set, get),
  
  // Waitlist logic actions
  ...createWaitlistActions(set, get),

  // Auth method actions
  ...createAuthMethodActions(set, get)
}));